import React, {useState} from "react";
import EditUserDetailComponent from "./EditUserDetailComponent";
import {IonCol, IonContent, IonHeader, IonMenu, IonRow, IonToolbar} from "@ionic/react";
import useStore from "../zustand/useStore";
import {useHistory, useLocation} from "react-router";
import moment from "moment-timezone";

const menuItems = [
    { label: 'Home', pathName:'/dashboard/home' },
    { label: 'About AICAS', pathName:'/dashboard/about-us' },
    { label: 'Become a Member', pathName: '/dashboard/membership' },
    {
        label: 'Initiatives',
        children: [
            { label: 'CFO World', pathName:'/dashboard/cfoworld' },
            { label: 'FICAF', pathName:'/dashboard/ficaf' },
            { label: 'Committees', pathName:'/dashboard/committees' },
        ],
    },
    { label: 'Policy', pathName:'/dashboard/policy' },
    { label: 'Deactivate Account', pathName:'/dashboard/deactivate' },
    { label: 'Contact Us', pathName:'/dashboard/contact-us' },
];

const versionNumber = `2.5.2`;

export default function LeftSideMenuComponent({pageId,setMenuOpen,setCurrentPath,menuRef,isMobile,callFunctionToLogoutUser,menuId}){
    const {userAuthDetail,openEditUserDetail, setOpenEditUserDetail} = useStore();
    const {userInfo} = userAuthDetail;
    const {pathname} = useLocation();
    const history = useHistory();
    const {currentMemberMemberShipDetail} = useStore();
    const {memberShipDetail} = currentMemberMemberShipDetail;

    const goToPage =(page)=>{
        const menu = menuRef.current;
        if(isMobile){
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
                setMenuOpen(false)
            }
        }else{
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
                setMenuOpen(false)
            }
        }
    }

    const closeMenu = ()=>{
        const menu = menuRef.current;
        if (menu) {
            menu?.close();
            setMenuOpen(false)
        }
    }

    return(
        <>
            {/* Mobile/Tablet Slide Menu */}
            <IonMenu side="start" menuId={menuId} menuRef={menuRef} contentId={pageId}>
                <IonHeader className={"with_login-header"}>
                    <IonToolbar className={"with_login-toolbar in-left-menu"}>
                        <div className="with_login-menu-item ">
                            <IonRow className={"with_login-menu-item-header-row"} onClick={()=>{closeMenu(); setOpenEditUserDetail(true)}}>
                                <IonCol size="3">
                                    <div className={"profile-avatar user_prof_initial"}>
                                        <div className={"user_name_initial"}>
                                            {(userInfo?.profile_image_url) ?
                                                <div className={"user_avatar_img_in_profile"}>
                                                    <img src={userInfo?.profile_image_url} alt={userInfo?.name}/>
                                                </div>
                                                :
                                                <div className={"user_name"}>
                                                    {userInfo?.name?.substr(0,1).toUpperCase()}
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </IonCol>
                                <IonCol size="9">
                                    <div className={"user_full_info"}>
                                        <div className="user_full_name">{userInfo?.name}</div>
                                        <div className="user_full_email">{userInfo?.email}</div>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </div>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <div className="home_membership_menu">
                        {/*Become a Member*/}

                        {(memberShipDetail?.id) ?
                            (memberShipDetail?.membership_type === 'Annual') ?
                                <div className="card success annual-membership">
                                    <p>Annual Member Upto: {moment(memberShipDetail?.end_date).format('MMM DD, YYYY')}</p>
                                    <div className="membership-annual-button-group">
                                        <button onClick={()=>goToPage('/dashboard/membership')}>Renew Annual Membership</button>
                                        <button onClick={()=>goToPage('/dashboard/membership')}>Upgrade to Life Membership</button>
                                    </div>
                                </div>
                                :
                                <div className="card lifetime">
                                    <h4><strong>Lifetime Member</strong> </h4>
                                    <h5>Since:  Jan 1, 2024</h5>
                                </div>
                            :
                            <div className="card primary">
                                <h4>Become a Member</h4>
                                <div className="membership-annual-button-group">
                                    <button onClick={()=>goToPage('/dashboard/membership')} className="green-sucess">Annual Member</button>
                                    <button onClick={()=>goToPage('/dashboard/membership')} className="golden-sucess">Life Member</button>
                                </div>
                            </div>
                        }


                        {/*Annual Membership*/}



                    </div>
                    <div className="with_login-mobile-menu">
                        {/* Close button at top of menu */}
                        {menuItems.map((item, index) => (
                            <div key={index} className="menu-section">
                                <div
                                    onClick={() => {
                                        if (item.pathName) {
                                            goToPage(item.pathName);
                                        }
                                    }}
                                    className={`with_login-menu-item menu-names ${
                                        pathname === item?.pathName ? 'active' : ''
                                    }`}
                                >
                                    <span>{item.label}</span>
                                </div>

                                {item.children && (
                                    <div className="submenu">
                                        {item.children.map((child, childIndex) => (
                                            <div
                                                key={childIndex}
                                                onClick={() => goToPage(child.pathName)}
                                                className={`with_login-menu-item submenu-item ${
                                                    pathname === child?.pathName ? 'active' : ''
                                                }`}
                                            >
                                                <span>{child.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className="menu-section">
                            <div
                                onClick={() => callFunctionToLogoutUser()}
                                className={`with_login-menu-item menu-names`}>
                                <span className={"logout"}>Log Out</span>
                            </div>
                        </div>
                        <div className="with_login-menu-item version_no_section">
                            <div className={"version_no_section"}>Version {versionNumber}</div>
                        </div>
                    </div>
                </IonContent>
            </IonMenu>
            {/* Mobile/Tablet Slide Menu */}
            {(openEditUserDetail) &&
                <EditUserDetailComponent isOpen={openEditUserDetail} onClose={()=>setOpenEditUserDetail(false)}/>
            }
        </>
    )
}